import { takeEvery, put } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from "../../services/apiUrls";

import { toastError, toastSuccess } from "../../utils/react-toaster";
import {
  addNewOptionSetData,
  deleteOptionSetData,
  deleteOptionSetVariantData,
  getAllOptionSetsData,
  getSingleOptionSetData,
  saveAllOptionSetsData,
  updateOptionSetData,
} from "../slices";
import { removeFalsyValues } from "../../helpers/common-helper";

export interface ResponseGenerator {
  config?: any;
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
  success?: boolean;
  code?: any;
  results?: any;
  productvo?: any;
}

function* fetchAllOptionSets(actions?: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ADD_ONS.getAllOptionSetsApi,
      data: actions.payload.dataToPost,
    });
    if (response) {
      yield put(saveAllOptionSetsData({ response, addOnsAction: actions.payload.addOnsAction }));
    }
  } catch (error) {
    console.log(error);
  }
}

function* fetchSingleOptionSet(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.ADD_ONS.getSingleOptionSetDataApi(
        actions.payload.optionSetId
      ),
    });
    if (response) {
      actions.payload.callback && actions.payload.callback(response);
    }
  } catch (error) {
    console.log(error);
  }
}

function* addNewOptionSet(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ADD_ONS.createOptionSetApi,
      data: removeFalsyValues(actions.payload.dataToPost),
    });
    if (!response?.code) {
      actions.payload.callback(response);
    }
  } catch (error) {
    console.log(error);
  }
}

function* updateOptionSet(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ADD_ONS.updateOptionSetApi,
      data: removeFalsyValues(actions.payload.dataToPost),
    });
    if (!response?.code) {
      actions.payload.callback && actions.payload.callback(response);
    } else if (response?.code === 'REST_OPTIONSET_DUPLICATE_BRANCHES') {
      toastError(`Can't duplicate branch and channel combination.`);
    } else {
      toastError(response?.code);
    }
  } catch (error) {
    console.log(error);
  }
}

function* deleteOptionSet(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `DELETE`,
      url: ENDPOINT.ADD_ONS.deleteOptionSetApi(actions.payload.optionSetId),
    });
    if (response.code) {
      if (response.code === 'REST_OPTIONSET_HAS_REFERENCES') {
        toastError('Add on referenced in some items.');
      } else {
        toastError(response.code);
      }
      actions.payload.callback && actions.payload.callback(false);
    } else {
      actions.payload.callback && actions.payload.callback(true);
    }
  } catch (error) {
    actions.payload.callback && actions.payload.callback(false);
    console.log(error);
  }
}

function* deleteOptionSetVariant(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `DELETE`,
      url: ENDPOINT.ADD_ONS.deleteOptionSetVariantApi(
        actions.payload.optionSetId,
        actions.payload.variantId
      ),
    });
    if (response.code) {
      toastError(response.code);
      // actions.payload.callback && actions.payload.callback(false);
    } else {
      actions.payload.callback && actions.payload.callback(true);
    }
  } catch (error) {
    // actions.payload.callback && actions.payload.callback(false);
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(getAllOptionSetsData.type, fetchAllOptionSets);
  yield takeEvery(getSingleOptionSetData.type, fetchSingleOptionSet);
  yield takeEvery(addNewOptionSetData.type, addNewOptionSet);
  yield takeEvery(updateOptionSetData.type, updateOptionSet);
  yield takeEvery(deleteOptionSetData.type, deleteOptionSet);
  yield takeEvery(deleteOptionSetVariantData.type, deleteOptionSetVariant);
}
